import { createContext, useContext } from "react";
import type { ApiError } from "../api/ApiClient";

export interface Customer {
  customerNumber: string;
  customerId: string;
  hasMembership: boolean;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
}

export interface ICustomerContext {
  isLoggedIn: boolean;
  isLoading: boolean;
  result: Customer | null;
  error: ApiError | null;
}

export const CustomerContext = createContext<ICustomerContext | null>(null);

export function useCustomer() {
  const context = useContext(CustomerContext);

  if (!context) throw new Error("No CustomerContext found!");

  return context;
}
